<template>
  <div>
    <warning-step
        title="Hmm. Something went wrong."
        description="Please check your internet connection and try again." />

    <div class="verification-method-selection__step__right-aligned-button-container">
      <el-button
          type="primary"
          class="account-verification__step__button"
          @click="requestRetry">
        Try Again
      </el-button>
    </div>
  </div>
</template>

<script>
import WarningStep from "./WarningStep";
export default {
  name: "InternetConnectionErrorStep",
  emits: ["previousStepRequested"],
  components: { WarningStep },
  methods: {
    requestRetry() {
      this.$emit("previousStepRequested", true);
    },
  },
};
</script>

<style scoped>
.verification-method-selection__step__right-aligned-button-container {
  text-align: right;
  margin-top: 70px;
}
</style>
